<template>
<!-- 按货位盘点 -->
  <div>
    <!-- 基础信息 S -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="color:#222;font-weight:600">基础信息</span>
        <el-tooltip class="item" effect="dark" style="float: right; padding: 3px 0;color:#969696;font-size:14px" placement="bottom-start">
          <div slot="content">按商品总数盘点：盘点商品在仓库的总数量(效期商品按日期盘点)；<br>按商品货位盘点：盘点商品在指定库区中的数量；<br>按货位盘点：盘点货位上每种商品的数量。<br>
          </div>
          <span>盘点类型说明 <i class="el-icon-warning-outline"></i></span>
        </el-tooltip>
      </div>
      <el-form :inline="true" :model="planFrom" class="demo-form-inline" label-width="160px">
        <el-form-item label="盘点类型：" required>
          <span>按货位盘点</span>
        </el-form-item>
        <el-form-item label="盘点库区：" required>
          <el-select v-model="planFrom.yaId" placeholder="请选择" @change="changeYaid">
            <el-option v-for="(item,index) in reservoirAreaList" :key="index" :label="item.yaName" :value="item.yaId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 基础信息 E -->
    <!-- 盘点明细 S -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="color:#222;font-weight:600">盘点明细</span>
      </div>
      <el-button type="primary" @click="add">+新增货位</el-button>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="yaName" label="库区" min-width="170" align="center"></el-table-column>
        <el-table-column prop="ylCode" label="货位编码"  min-width="80" ></el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click.native.prevent="deleteRow(scope.$index, tableData)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="submit-btn">
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-card>
    <!-- 盘点明细 E -->
    <!-- 弹窗 S -->
    <el-dialog title="新增货位" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
       <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="80px">
        <el-form-item>
          <el-input placeholder="请输入货位编码" v-model="searchForm.ylCode"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="searchForm.checked">只显示有货货位</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <page-table ref='pageTable'
                  :list="cargoSpaceList"
                  :fieldList="tableFieldList"
                  :selection="true"
                  deleteName="id"
                  :reserveSelection="true"
                  :selectable="selectable"
                  rowKey="ylId">
        <template v-slot:col-skuZs="scope">
          <span>{{scope.row.skuZs}}</span>
        </template>
        <template v-slot:col-zs="scope">
          <span>{{scope.row.zs}}</span>
        </template>
      </page-table>
      <span slot="footer" class="dialog-footer">
        <div style="color:#969696;font-size:14px;text-align:left;margin-bottom:8px">已选、盘点单未完成，或盘点损益未处理的货位不可重复盘点。</div>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗 E -->
  </div>
</template>
<script>
import liquidationManage from '@/store/liquidationManage/index'
import { GETLOCATIONDETAIL, SAVELIQUIDATIONPLAN, CHECKTASK } from '@/store/liquidationManage/types'
import { GETRESERVOIRAREALIST } from '@/store/reservoirAreaManage/types.js'
import reservoirAreaManage from '@/store/reservoirAreaManage/index'
import pageTable from '@/components/Table/Index'
import { CLOSECURRENTTAG } from '@/store/user/types'

let _self
export default{
  components: {
    pageTable
  },
  name: 'addPlanLocation',
  data () {
    return {
      planFrom: {},
      tableData: [], // 货位列表
      multipleSelection: [], // 选中信息
      dialogVisible: false,
      searchForm: {
        ylCode: null,
        checked: true
      },
      disableCargoSpace: [], // 不可选择的货位
      currentSelect: null,
      warehouseCode: ''
    }
  },
  computed: {
    // 货位信息
    cargoSpaceList () {
      return {
        rows: liquidationManage.state.cargoSpaceList
      }
    },
    // 库区
    reservoirAreaList () {
      return reservoirAreaManage.state.reservoirAreaList.rows
    },
    // 表格字段
    tableFieldList () {
      return [
        { label: '库区', prop: 'yaName', width: 150, align: 'center' },
        { label: '货位编码', prop: 'ylCode', width: 150, align: 'center' },
        { label: 'SKU种数', prop: 'skuZs', width: 150, align: 'center', type: 'slot' },
        { label: '总数量', prop: 'zs', width: 150, align: 'center', type: 'slot' }
      ]
    },
    pageTable () {
      return this.$refs.pageTable.$refs.table
    },
    addPlanMark () {
      return liquidationManage.state.addPlanMark
    },
    planSave () {
      return liquidationManage.state.planSave
    }
  },
  watch: {
    addPlanMark (newVal) {
      if (newVal === 1) {
        liquidationManage.state.addPlanMark = 0
        this.$store.dispatch(CLOSECURRENTTAG, '/liquidationManage/liquidationPlan')
      }
    },
    planSave (newVal) {
      if (newVal.code === 503) {
        let arr = []
        newVal.list.forEach(item => {
          arr.push(item.ylCode)
          this.disableCargoSpace.push(item.ylCode)
        })

        this.$confirm(arr.join('、') + '已在盘点或损益未处理，不可重复盘点。', '提示', {
          confirmButtonText: '删除问题货位并保存',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          for (var i = 0; i < this.tableData.length; i++) {
            if (arr.indexOf(this.tableData[i].ylCode) > -1) {
              this.tableData.splice(i, 1)
              i = i - 1
            }
          }
          liquidationManage.state.planSave = {}
          this.save()
        }).catch(() => {
          liquidationManage.state.planSave = {}
        })
      } else if (newVal.code === 502) {
        this.$message({
          message: newVal.describe,
          type: 'warning'
        })
        liquidationManage.state.planSave = {}
      }
    },
    $route (to, from) {
      this.warehouseCode = this.$route.params.warehouseCode
      this.getReservoirAreaList()
    }
  },
  mounted () {
    _self = this
    this.warehouseCode = this.$route.params.warehouseCode
    this.getReservoirAreaList()
  },
  methods: {
    // 新增货位
    add () {
      if (!this.planFrom.yaId) {
        this.$confirm('请选择盘点库区！', '提示', {
          confirmButtonText: '知道了',
          type: 'warning',
          showCancelButton: false
        })
        return
      }
      this.search()
      this.dialogVisible = true
      this.setSelection()
    },
    // 获取货位信息

    // 提交信息
    submit () {
      let ylIds = []
      this.pageTable.selection.forEach(item => {
        ylIds.push(item.ylId)
      })
      let params = {
        yipType: this.$route.params.type,
        yaId: this.planFrom.yaId,
        ylIds: ylIds.join(','),
        warehouseCode: this.warehouseCode
      }
      let list = new Promise((resolve, reject) => {
        _self.$store.dispatch(CHECKTASK, params).then(res => {
          if (res.obj && res.obj.code === 502) { // 已存在未完成的盘点单 不允许新增 关闭窗口
            this.$message({
              message: res.obj.describe,
              type: 'warning'
            })
          } else if (res.obj && res.obj.code === 503) { // 已存在未完成的盘点货位 不允许新增
            let arr = []
            res.obj.list.forEach(item => {
              arr.push(item.ylCode)
              this.disableCargoSpace.push(item.ylCode)
            })

            this.$confirm(arr.join('、') + '已在盘点或损益未处理，不可重复盘点。', '提示', {
              confirmButtonText: '删除问题货位并保存',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.tableData = [...this.pageTable.selection]
              this.pageTable.selection.forEach((item, index) => {
                if (arr.indexOf(item.ylCode) > -1) {
                  delete this.tableData[index]
                }
              })
              for (var i = 0; i < this.tableData.length; i++) {
                if (!this.tableData[i]) {
                  this.tableData.splice(i, 1)
                  i = i - 1
                }
              }
              this.handleClose()
            }).catch(() => {})
          } else {
            if (this.pageTable.selection.length > 0) {
              let arrStr = JSON.stringify(this.tableData)
              this.pageTable.selection.forEach(item => {
                if (arrStr.indexOf(item.ylId) === -1) {
                  this.tableData.push(item)
                }
              })
            }
            this.handleClose()
          }
        })
      })
      console.log(list)
    },
    // 关闭窗口
    handleClose () {
      this.dialogVisible = false
      this.pageTable.clearSelection()
    },
    // 保存
    save () {
      if (!this.planFrom.yaId) {
        this.$confirm('请选择盘点库区！', '提示', {
          confirmButtonText: '知道了',
          type: 'warning',
          showCancelButton: false
        })
        return
      }
      if (this.tableData.length === 0) {
        this.$message({
          message: '请添加货位',
          type: 'warning'
        })
        return
      }
      let ylIds = []
      this.tableData.forEach(item => {
        ylIds.push(item.ylId)
      })
      let params = {
        yipType: this.$route.params.type,
        yaId: this.planFrom.yaId,
        ylIds: ylIds.join(','),
        warehouseCode: this.warehouseCode
      }
      this.$store.dispatch(SAVELIQUIDATIONPLAN, params)
    },
    // 搜索
    search () {
      if (this.dialogVisible) {
        this.pageTable.clearSelection()
        this.setSelection()
      }
      let params = {
        yaId: this.planFrom.yaId,
        ylCode: this.searchForm.ylCode,
        ylCargo: this.searchForm.checked ? 1 : 2,
        warehouseCode: this.warehouseCode
      }
      this.$store.dispatch(GETLOCATIONDETAIL, params)
    },
    // 重置
    reset () {
      this.searchForm = {
        ylCode: null,
        checked: true
      }
      this.search()
    },
    // 选择
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 获取库区下拉框
    getReservoirAreaList () {
      let params = {
        warehouseCode: this.warehouseCode
      }
      this.$store.dispatch(GETRESERVOIRAREALIST, params)
    },
    // 设置禁止选择
    selectable ({ylId, ylCode}) {
      let arr = []
      this.tableData.forEach(item => {
        arr.push(item.ylId)
      })

      if (arr.indexOf(ylId) > -1 || this.disableCargoSpace.indexOf(ylCode) > -1) {
        return false
      }
      return true
    },
    // 删除
    deleteRow (index, rows) {
      rows.splice(index, 1)
    },
    // table设置选中
    setSelection () {
      let arr = JSON.parse(JSON.stringify(this.tableData))
      this.$nextTick(() => {
        arr.forEach(item => {
          this.pageTable.toggleRowSelection(item)
        })
      })
    },
    changeYaid (val) {
      if (this.tableData.length > 0) {
        this.$confirm('修改后，下方已选货位将清空，需重新添加，您确定修改吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData = []
          this.disableCargoSpace = []
          this.currentSelect = val
        }).catch(() => {
          this.planFrom.yaId = this.currentSelect
        })
      } else {
        this.currentSelect = val
      }
    }

  }
}
</script>
<style scoped>
 .submit-btn {
   margin:10px 20px 10px;
   float: right;
  }
</style>



// WEBPACK FOOTER //
// src/page/liquidationManage/addPlan/addPlanLocation.vue